import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './history.scss';
import Title from '../../elements/title';
import Img from '../../../components/image';
import IconCross from '../../../images/icon-cross.svg';
const History = () => {
	return (
		<section id='history' className='section-padding'>
			<div className='history-background'>
				<div className='background-overlay'></div>
				<div className='background-image'>
					<Img src='imageGlobe' />
				</div>
			</div>
			<Container>
				<Row>
					<Col lg={7}>
						<h2>
							Thomas und Adrian
							<br />
							Die Begründer Sustragils
						</h2>

						<p className='d-none d-lg-block '>
							Thomas hat seit mehr als zehn Jahren nach einem Weg gesucht,
							produktsicherheitsspezifische Informationen mit einer einfachen
							und nachvollziehbaren Durchgängigkeit zu nutzen, als er auf Adrian
							traf - den perfekten Partner mit technischem Verständnis. <br />
							<br />
							Die gemeinsame Vision: Eine Transparenz vom Bohrloch bis zum
							Endprodukt schaffen, ohne dass in Unternehmen die gleichen
							Tätigkeiten immer und immer wieder anfallen. Mit Unterstützung des
							Business Inkubators der BASF und erfahrender Gründer, wurde dann
							aus einer Vision, eine umsetzbare Idee und ein Produkt -
							<br />
							<br />
							Sustragil. Heute stecken hinter Sustragil nicht mehr nur Thomas
							und Adrian, sondern ein 15-köpfiges Team, das jeden Tag auf
							Hochtouren daran arbeitet, die Produktsicherheit der Zukunft
							mitzugestalten.
						</p>
					</Col>
					<Col lg={5} className='col-image'>
						<div className='team-image'>
							<Img src='imageTeamNormal' />
							<div className='shadow-overlay'></div>
						</div>
						<p className='d-block d-lg-none'>
							Thomas hat seit mehr als zehn Jahren nach einem Weg gesucht,
							produktsicherheitsspezifische Informationen mit einer einfachen
							und nachvollziehbaren Durchgängigkeit zu nutzen, als er auf Adrian
							traf - den perfekten Partner mit technischem Verständnis. <br />
							<br />
							Die gemeinsame Vision: Eine Transparenz vom Bohrloch bis zum
							Endprodukt schaffen, ohne dass in Unternehmen die gleichen
							Tätigkeiten immer und immer wieder anfallen. Mit Unterstützung des
							Business Inkubators der BASF und erfahrender Gründer, wurde dann
							aus einer Vision, eine umsetzbare Idee und ein Produkt -
							<br />
							<br />
							Sustragil. Heute stecken hinter Sustragil nicht mehr nur Thomas
							und Adrian, sondern ein 15-köpfiges Team, das jeden Tag auf
							Hochtouren daran arbeitet, die Produktsicherheit der Zukunft
							mitzugestalten.
						</p>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default History;
